// Default production API host.
const SIKHIO_API_BASE = "https://sikhio-digital-twin-api.drnon.workers.dev";

// Sibling dashboards' API hosts, deliberately REFUSED.
//
// This is not fork drift — it is a guard. Every Nonarkara dashboard shares
// this file's ancestry, so a `VITE_API_BASE_URL` copied from Chula or
// Chonburi (either from an old build or from a sibling project's Cloudflare
// Pages settings) would otherwise be accepted verbatim, and this dashboard
// would silently render another municipality's incidents, air quality and
// news under Sikhio's name. Refusing these hosts and falling back to the
// Sikhio worker is the only safe behaviour.
//
// Do not "clean up" the names below as unused: they are inputs that must
// keep failing to match. A new sibling dashboard should be added here.
const LEGACY_API_HOSTS = new Set([
  "https://chula-api.nonarkara.org",
  "http://chula-api.nonarkara.org",
  "https://chonburi-api.nonarkara.org",
  "https://chonburi-control-tower-api.drnon.workers.dev",
]);

// Note: an earlier version of this file also refused
// `https://chonburi-api.nonarkara.org` because the alias has no DNS record —
// every request from a built bundle failed with ERR_NAME_NOT_RESOLVED,
// leaving every panel stuck on "Loading…". That is now covered by the default
// constant above; the DNS alias itself was never fixed at the registrar.
function normalizeBase(raw: string | undefined): string {
  return (raw ?? "").trim().replace(/\/+$/, "");
}

export function resolveApiBase(raw: string | undefined = import.meta.env.VITE_API_BASE_URL): string {
  const base = normalizeBase(raw);
  const isLegacy = LEGACY_API_HOSTS.has(base);

  if (import.meta.env.DEV && (!base || isLegacy)) {
    return "";
  }

  if (!base || isLegacy) {
    return SIKHIO_API_BASE;
  }

  return base;
}

export const API_BASE = resolveApiBase();
